
<div>
  <div class="asm-bar-branding">
  </div>
  <div class="asm-bar-actions"></div>
  <div class="asm-section">
    <div class="asm-menu">
      <nav class="navbar">
        <div class="container-fluid">
          <ul class="nav navbar-nav">
            <li>Sanofi Rules
              <span class="chevronIcondown fas fa-angle-down"></span>
              <span class="chevronIconup fas fa-angle-up"></span>
              <span class="accMenubtn-shade"></span>
              <div class="acc-secondMenu rules">
                <ul class="col-md-12 col-sm-12 lap">
                  <li>
                    <a target="_blank" (click)="goByUrl('/sanofiRulesPage')"
                      title="Sanofi Rules Config Upload/DownLoad">
                      Sanofi Rules Config Upload/Download
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li>STS Admin
              <span class="chevronIcondown fas fa-angle-down"></span>
              <span class="chevronIconup fas fa-angle-up"></span>
              <span class="accMenubtn-shade"></span>
              <div class="acc-secondMenu">
                <ul class="col-md-12 col-sm-12">
                  <li>
                    <a title="STS Customer Upload" (click)="goByUrl('/stsAdminCustomerInfo')" target="_blank"
                    rel="noopener noreferrer">STS Customer Upload</a>
                  </li>
                  <li>
                    <a title="STS Shipping Commitment" (click)="goByUrl('/shipCommitmentPage')" target="_blank"
                      rel="noopener noreferrer">STS Shipping
                    Commitment</a>
                  </li>
                  <li>
                    <a title="STS Tier Management" (click)="goByUrl('/tiermanagementpage')" target="_blank"
                    rel="noopener noreferrer">STS Tier Management</a>
                  </li>
                  <li>
                    <a title="STS Marketing Analysis" (click)="goByUrl('/stsMarketingAnalysisPage')" target="_blank"
                      rel="noopener noreferrer">STS Marketing
                    Analysis</a>
                  </li>
                  <li>
                    <a title="STS Shipping Week" (click)="goByUrl('/stsAdminShippingWeekPage')" target="_blank"
                    rel="noopener noreferrer">STS Shipping Week</a>
                  </li>
                  <li>
                    <a title="STS Order Export" target="_blank" rel="noopener noreferrer"
                    (click)="goByUrl('/stsOrderExportPage')">STS Order Export</a>
                  </li>
                </ul>
              </div>
            </li>
            <span (click)="asmClose()">
              <img src="/icons/close_new.svg" class="asm_close">
            </span>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</div>

@if ((isAsmEnabled || !(isCollapsed$ | async)); as notCollapsed) {
  @if (isAsmEnabled || (customerSupportAgentLoggedIn$ | async)) {
    @if (customer$ | async) {
      @if (notCollapsed) {
        <vsca-cx-customer-emulation></vsca-cx-customer-emulation>
      }
    } @else {
      @if (notCollapsed) {
        <vsca-cx-customer-selection (submitEvent)="startCustomerEmulationSession($event)">
        </vsca-cx-customer-selection>
      }
    }
  }
}
